import React from 'react';
import ExternalLink from 'components/link';
import { Field } from 'components/form';
import { slugify, singularize } from 'utils';
import { storefrontCollectionLink } from 'utils/storefront';

export default function StorefrontSlugField(props) {
  const {
    collection,
    storefronts,
    record = {},
    values = {},
    name = 'slug',
    ...attrs
  } = props;

  const defaultValue = slugify(values?.[name]);
  const placeholder =
    record?.[name] || slugify(values?.name) || slugify(values?.title);

  const slugExampleLink = storefrontCollectionLink(
    collection,
    {
      ...values,
      slug:
        values?.[name] ||
        placeholder ||
        '...',
    },
    storefronts.primary,
  );

  const slugExampleText = slugExampleLink.replace(/^http(s)?:\/\//, '');

  return (
    <Field
      type="text"
      name="slug"
      label="Slug"
      help={`Used to uniquely identify the ${singularize(collection)} in a storefront URL`}
      defaultValue={defaultValue}
      placeholder={placeholder}
      hint={
        record?.id ? (
          <ExternalLink to={slugExampleLink}>{slugExampleText}</ExternalLink>
        ) : (
          slugExampleText
        )
      }
      required={Boolean(record?.id)}
      maxLength={70}
      className="span4"
      {...attrs}
    />
  );
}
